<header id="te-header" class="te-header te-hidden-sm">
    <div style="display: block; width: 100%; height: 10px;" class="te-primary-bg"></div>
    <div class="te-row-full" style="align-items: center;">
        <div style="margin: 5px 5px 5px 20px;">
            <img src="/Common/assets/tec_tab_rgb_orn.jpg" title="TE Connectivity" height="68">
        </div>
        <div class="te-header-main-text">
            {{'myIDSSP' | translate}}
        </div>
        <div class="te-row-full te-header-links">
            <a style="padding: 20px;" title="{{'EnterpriseDirectory'| translate}}" href="https://enterprisedirectory.connect.te.com/Home" target="_blank">
                <!--<mat-icon style="font-size: 48px; width: 48px; height: 48px; color: white;">groups</mat-icon>-->
                <!--remove the below line and uncomment the above line once we upgrade to angular 21-->
                <img src="/Common/assets/groups_48.png"  style="font-size: 48px; width: 48px; height: 48px; color: white;">
            </a>
           
        </div>
    </div>
</header>
<nav style="min-height: 55px;" class="te-desktop-nav">
    <div id="te-nav-affix" class="te-navbar" data-spy="affix" data-offset-top="88">
        <div *ngIf="loggedIn" class="te-row-full" style="align-items: center; padding: 10px; margin: 0;">
            <button mat-menu-item routerLink="/Home" style="width: auto;" title="{{'myIDHome' | translate}}">
                {{'myIDHome' | translate}}
            </button>
            <button *ngIf="!isAppIdUser && !isMFARegistered" mat-menu-item style="width: auto;" (click)="openExternalLink()"
                    title="{{'MFASetUpNote' | translate }}">
                 My Sign-Ins
            </button>
            <mat-menu #placeHolderMenu="matMenu" overlapTrigger="false"></mat-menu>
            <button mat-menu-item style="margin-left: auto; width: auto;" (click)="toggleDarkMode()" title="{{getToolTip()}}">
                <mat-icon class="te-nav-button" style="font-size: 24px !important;">brightness_4</mat-icon>
            </button>
            <button mat-menu-item style="width: auto;" (click)="setLanguage()"
                    title="{{'ChangeLanguage' | translate}}">
                {{'ChangeLanguage' | translate}}
            </button>
            <button mat-menu-item style="width: auto;" (click)="signOut()"
                    title="{{'SignOut' | translate}}">
                {{'SignOut' | translate}}
            </button>
        </div>
        <div *ngIf="!loggedIn && !login" class="te-row-full" style="align-items: center; padding: 10px; margin: 0;">
            <mat-menu #placeHolderMenu="matMenu" overlapTrigger="false"></mat-menu>
            <!-- The placeHolderMenu is needed for the button "mat-menu-item" below to look the same as when logged in -->
            <button mat-menu-item style="margin-left: auto; width: auto;" (click)="toggleDarkMode()"
                    title="{{getToolTip()}}" >
                <mat-icon class="te-nav-button" style="font-size: 24px !important;">brightness_4</mat-icon>
            </button>
            <button mat-menu-item style="width: auto;" (click)="setLanguage()"   
                    title="{{'ChangeLanguage' | translate}}">
                {{'ChangeLanguage' | translate}}
            </button>
        </div>
        <div *ngIf="login" class="te-row-full" style="align-items: center; padding: 10px; margin: 0;">
            <mat-menu #placeHolderMenu="matMenu" overlapTrigger="false"></mat-menu>
            <!-- The placeHolderMenu is needed for the button "mat-menu-item" below to look the same as when logged in -->
            <button mat-menu-item style="margin-left: auto; width: auto;" (click)="toggleDarkMode()"
                    title="{{getToolTip()}}" >
                <mat-icon class="te-nav-button" style="font-size: 24px !important;">brightness_4</mat-icon>
            </button>
            <button mat-menu-item style="width: auto;" (click)="setLanguage()"   
                    title="{{'ChangeLanguage' | translate}}">
                {{'ChangeLanguage' | translate}}
            </button>
            <button mat-menu-item style="width: auto;" (click)="signOut()"
                    title="{{'SignOut' | translate}}">
                {{'SignOut' | translate}}
            </button>
        </div>
    </div>
</nav>
<nav class="te-mobile-nav" style="min-height: 55px;">
    <div class="te-navbar-mobile">
        <div *ngIf="loggedIn" class="te-col-start">
            <span class="te-row-full">
                <button mat-button class="te-nav-button" routerLink="/Home" (click)="dismissMenu()"
                        title="{{'myIDHome' | translate}}">
                    {{'myIDHome' | translate}}
                </button>
                <button *ngIf="!isAppIdUser && !isMFARegistered" mat-button class="te-nav-button" (click)="openExternalLink()"
                        title="{{'MFASetUpNote' | translate }}">
                    My Sign-Ins
                </button>
                <button mat-button class="te-nav-button" style="text-align: right;" (click)="toggleMenu()"><mat-icon style="color: white;">menu</mat-icon></button>

            </span>
            <span *ngIf="showMenu" class="te-col-start">
                <button mat-button class="te-nav-button" routerLink="/ResetPassword" (click)="dismissMenu()" title="{{'ResetPwdOption' | translate}}">{{'ResetPwdOption' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/UnlockAccount" (click)="dismissMenu()" title="{{'UnlockOption' | translate}}">{{'UnlockOption' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/Preferences/SecurityQuestions" (click)="dismissMenu()" title="{{'SecurityQuesOption' | translate}}"><!--Security Questions-->{{'SecurityQuesOption' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/Preferences/myIDPin" (click)="dismissMenu()" title="{{'SecurityPIN' | translate}}">{{'SecurityPIN' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/Preferences/ExternalEmail" (click)="dismissMenu()" title="{{'ExtMailOption' | translate}}"><!--External Email-->{{'ExtMailOption' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/CurrentErgMembership" (click)="dismissMenu()" title="{{'ActiveMembership' | translate}}"><!--Active Erg Membership-->{{'ActiveMembership' | translate}}</button>
                <button mat-button class="te-nav-button" routerLink="/RequestErgMembership" (click)="dismissMenu()" title="{{'RequestNewMembership' | translate}}"><!--Request Erg Memership-->{{'RequestNewMembership' | translate}}</button>
                <button mat-button class="te-nav-button" (click)="toggleDarkMode(); dismissMenu()" title="{{getToolTip()}}">{{getToolTip()}}</button>
                <button mat-button class="te-nav-button" (click)="setLanguage(); dismissMenu()" title="{{'ChangeLanguage' | translate}}">{{'ChangeLanguage' | translate}}</button>
                <button mat-button class="te-nav-button" (click)="signOut()" title="{{'SignOut' | translate}}">{{'SignOut' | translate}}</button>
            </span>
        </div>
        <div *ngIf="!loggedIn" class="te-col-start">            
            <span class="te-row-full">
                <button mat-button class="te-nav-button" (click)="setLanguage(); dismissMenu()" title="{{'ChangeLanguage' | translate}}">{{'ChangeLanguage' | translate}}</button>
                <button mat-button class="te-nav-button" style="text-align: right;" (click)="toggleMenu()"><mat-icon style="color: white;">menu</mat-icon></button>
            </span>
            <span *ngIf="showMenu" class="te-col-start">
                <button mat-button class="te-nav-button" (click)="toggleDarkMode(); dismissMenu()" title="{{getToolTip()}}">{{getToolTip()}}</button>
            </span>
        </div>  
    </div>
</nav>   